import { render, staticRenderFns } from "./FooterClickLink.vue?vue&type=template&id=55857bc3"
import script from "./FooterClickLink.vue?vue&type=script&lang=js"
export * from "./FooterClickLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports